import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTooltipModule } from "@angular/material/tooltip";

import { DialogModule } from "@modules/shared/modules/dialog/dialog.module";
import { SharedModule } from "@modules/shared/shared.module";

import { AiModelsListComponent } from "./components/ai-models-list/ai-models-list.component";
import { AiModelFormDialogComponent } from "./components/ai-model-form-dialog/ai-model-form-dialog.component";
import { AiEntityTokensComponent } from "./components/ai-entity-tokens/ai-entity-tokens.component";
import { AiQuotaFormDialogComponent } from "./components/ai-quota-form-dialog/ai-quota-form-dialog.component";
import { AiUsageListComponent } from "./components/ai-usage-list/ai-usage-list.component";

@NgModule({
  declarations: [
    AiModelsListComponent,
    AiModelFormDialogComponent,
    AiEntityTokensComponent,
    AiQuotaFormDialogComponent,
    AiUsageListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild({ extend: true }),
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatTooltipModule,
    DialogModule,
    SharedModule,
  ],
  exports: [
    AiModelsListComponent,
    AiEntityTokensComponent,
    AiUsageListComponent,
  ],
})
export class AiTokensModule {}
